/** Chain 138 hub — align with docs/11-references/CONTRACT_ADDRESSES_REFERENCE.md */
export const CHAIN_ID = 138;

export const EXPLORER_BASE = 'https://explorer.d-bis.org';

/** Live PMM integration (Stack A) — see EXPLORER_TOKEN_LIST_CROSSCHECK / ADDRESS_MATRIX */
export const DODOPMM_INTEGRATION =
  '0x86ADA6Ef91A3B450F89f2b751e93B1b7A3218895' as const;

export const DODOPMM_PROVIDER =
  '0x3f729632E9553EBacCdE2e9b4c8F2B285b014F2e' as const;

export const TOKEN_AGGREGATION_BASE =
  (import.meta.env.VITE_TOKEN_AGGREGATION_API_BASE as string | undefined)?.replace(/\/$/, '') ||
  'https://dbis-api.d-bis.org';

export const RPC_URL_138 =
  (import.meta.env.VITE_RPC_URL_138 as string | undefined) || 'https://rpc.defi-oracle.io';

/** Canonical cUSDT / cUSDC on Chain 138 (see EXPLORER_TOKEN_LIST_CROSSCHECK) */
export const CANONICAL_CUSDT = '0x93E66202A11B1772E55407B32B44e5Cd8eda7f22';
export const CANONICAL_CUSDC = '0xf22258f57794CC8E06237084b353Ab30fFfa640b';
